import React from 'react';
import PropTypes from 'prop-types';

const SearchInput = ({ value, onChange, onKeyPress, placeholder = "Search...", autocomplete, uniqueId = "default" }) => {
  return (
    <div className="input-group input-group-flat w-auto">
      <span className="input-group-text">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
          viewBox="0 0 24 24" fill="none" stroke="currentColor"
          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
          className="icon icon-1">
          <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
          <path d="M21 21l-6 -6"></path>
        </svg>
      </span>
      <input
        type="text"
        className="form-control"
        placeholder={placeholder}
        autoComplete={autocomplete || "off"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyPress={onKeyPress}
        id={`search-input-${uniqueId}`}
      />
    </div>
  );
};

SearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func,
  placeholder: PropTypes.string,
  autocomplete: PropTypes.string,
  uniqueId: PropTypes.string
};

export default SearchInput;


